import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVerifiedShield = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m22.38 2.72-14 6.22A4.02 4.02 0 0 0 6 12.6V22c0 11.1 7.68 21.48 18 24 10.32-2.52 18-12.9 18-24v-9.4c0-1.58-.94-3.02-2.38-3.66l-14-6.22a3.98 3.98 0 0 0-3.24 0m-3.8 29.86L13.4 27.4c-.78-.78-.78-2.04 0-2.82s2.04-.78 2.82 0L20 28.34l11.76-11.76c.78-.78 2.04-.78 2.82 0s.78 2.04 0 2.82L21.4 32.58c-.76.78-2.04.78-2.82 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVerifiedShield;
